import React, { useCallback, useState } from 'react'
import { ModalContext, useConfigurationContext } from '../../core/application/contexts'
import MessageModal from '../modal/MessageModal'
import ModalContainer from '../modal/ModalContainer'
import ModalWithCloseCross from '../modal/ModalWithCloseCross'
import WasteTypeFilterModal from '../modal/wasteTypeFilterModal/WasteTypeFilterModal'

export interface IModalManagerProps {
  children?: React.ReactNode
}

const ModalManager: React.FC<IModalManagerProps> = ({ children }) => {
  const { wasteTypeList } = useConfigurationContext()
  const [wasteTypeFilterModal, setWasteTypeFilterModal] = useState<boolean>(false)
  const [messageModal, setMessageModal] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [messageCallback, setMessageCallback] = useState<() => void | undefined>()

  const closeMessageModal = () => {
    setMessage('')
    setMessageModal(false)
    messageCallback && messageCallback()
    setMessageCallback(undefined)
  }

  const openMessageModal = useCallback((msg: string, cb?: () => void) => {
    setMessage(msg)
    setMessageModal(true)
    setMessageCallback(() => cb)
  }, [])

  return (
    <>
      <ModalContext.Provider
        value={{
          setWasteTypeFilterModal,
          wasteTypeFilterModal,
          openMessageModal
        }}
      >
        {children}
      </ModalContext.Provider>
      <ModalContainer open={wasteTypeFilterModal}>
        <WasteTypeFilterModal
          onCancel={() => setWasteTypeFilterModal(false)}
          wasteTypes={wasteTypeList}
          onValidate={() => setWasteTypeFilterModal(false)}
        />
      </ModalContainer>
      <ModalWithCloseCross open={messageModal} onClose={closeMessageModal}>
        <MessageModal errorMessage={message} onOk={closeMessageModal} />
      </ModalWithCloseCross>
    </>
  )
}

export default ModalManager
